import { NavBar } from 'components/NavBar/NavBar'
import { Container, ContainerContent, ContainerHeader } from 'components/Containers/Containers'
import { Flex, PageWrapper } from 'styling/GlobalStyles'
import { OtherText, TitleText } from 'styling/Typography'

export const FoodEligibleEmployees = () => {
  return (
    <>
      <NavBar />
      <PageWrapper noFooter>
        <Flex column gap='1rem'>
          <Container>
            <ContainerHeader>
              <TitleText weight='700'>Eligible Employees</TitleText>
            </ContainerHeader>
            <ContainerContent>
              <OtherText grey>
                GET /v1/food/management/users is no longer available. Use Food → Profiles to create
                and edit employee food profiles (PUT /v1/food/management/profile/:userId).
              </OtherText>
            </ContainerContent>
          </Container>
        </Flex>
      </PageWrapper>
    </>
  )
}

export const provisioningModes = [
  { label: 'Mess / Hall', value: 1 },
  { label: 'Packout', value: 2 },
  { label: 'Opt-Out', value: 3 },
]
